import React from 'react';
import PropTypes from 'prop-types';

import DatePicker from 'components/DatePicker';

const Calendar = ({ startDate, endDate, setNewDates, availableDates }) => (
	<DatePicker
		setNewDates={setNewDates}
		startDate={startDate}
		endDate={endDate}
		availableDates={availableDates}
	/>
);

Calendar.propTypes = {
	startDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	endDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	setNewDates: PropTypes.func,
	availableDates: PropTypes.arrayOf(PropTypes.string)
};

export default Calendar;
